/// <amd-module name="Dashboards/Directory/redux/DashboardsDirectoryActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { Dashboard, DashboardFavoriteWithOwner, DashboardsAndOwnersLists, DashboardWithOwner, Owner } from "../DashboardsDirectoryContracts";

export const enum DashboardsDirectoryActionTypes {
    OpenNewDashboardDialog = "DashboardsDirectory/OpenNewDashboardDialog",
    OpenDashboardSecurityDialog = "DashboardsDirectory/OpenDashboardSecurityDialog",
    OpenDeleteDashboardDialog = "DashboardsDirectory/OpenDeleteDashboardDialog",
    InitialDataLoaded = "DashboardsDirectory/InitialDataLoaded",
    MyDashboardsLoaded = "DashboardsDirectory/MyDashboardsLoaded",
    MyOwnersLoaded = "DashboardsDirectory/MyOwnersLoaded",
    MyFavoritesLoaded = "DashboardsDirectory/MyFavoritesLoaded",
    MruDashboardLoaded = "DashboardsDirectory/MruDashboardLoaded",
    AllDashboardsAndTeamsLoaded = "DashboardsDirectory/AllDashboardsAndTeamsLoaded",
    AllDataLoaded = "DashboardsDirectory/AllDataLoaded",
    SetCanPerformDashboardActionsPermission = "DashboardsDirectory/SetCanPerformDashboardActionsPermission",
    SetCanUseTeamPanelPermission = "DashboardDirectory/SetCanUseTeamPanelPermission"
}

export const DashboardsDirectoryActions = {
    openNewDashboardDialog: () => createAction(DashboardsDirectoryActionTypes.OpenNewDashboardDialog),
    openDashboardSecurityDialog: (dashboardId: string, dashboardName: string, teamId: string) =>
        createAction(DashboardsDirectoryActionTypes.OpenDashboardSecurityDialog, { dashboardId, dashboardName, teamId }),
    openDeleteDashboardDialog: (dashboardId: string, teamId: string | undefined, projectId: string) =>
        createAction(DashboardsDirectoryActionTypes.OpenDeleteDashboardDialog, { dashboardId, teamId, projectId }),
    initialDataLoaded: () => createAction(DashboardsDirectoryActionTypes.InitialDataLoaded),
    myDashboardsLoaded: (dashboards: Dashboard[]) => createAction(DashboardsDirectoryActionTypes.MyDashboardsLoaded, dashboards),
    myOwnersLoaded: (owners: Owner[]) => createAction(DashboardsDirectoryActionTypes.MyOwnersLoaded, owners),
    myFavoritesLoaded: (favorites: DashboardFavoriteWithOwner[]) => createAction(DashboardsDirectoryActionTypes.MyFavoritesLoaded, favorites),
    mruDashboardLoaded: (mru: DashboardWithOwner) => createAction(DashboardsDirectoryActionTypes.MruDashboardLoaded, mru),
    allDashboardsLoaded: (dashboardsAndTeams: DashboardsAndOwnersLists) =>
        createAction(DashboardsDirectoryActionTypes.AllDashboardsAndTeamsLoaded, dashboardsAndTeams),
    allDataLoaded: () => createAction(DashboardsDirectoryActionTypes.AllDataLoaded),
    setCanPerformDashboardActionsPermission: (
        addPermission: boolean,
        manageSecurityPermission: boolean,
        deletePermission: boolean
    ) =>
        createAction(DashboardsDirectoryActionTypes.SetCanPerformDashboardActionsPermission, {
            addPermission,
            manageSecurityPermission,
            deletePermission
        }),
    setCanUseTeamPanelPermission: (canUseTeamPanelPermission: boolean) =>
        createAction(DashboardsDirectoryActionTypes.SetCanUseTeamPanelPermission, canUseTeamPanelPermission)
};

export type DashboardsDirectoryActions = ActionsUnion<typeof DashboardsDirectoryActions>;
